import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LeaderEmpowerments, UserEmpowerments } from '../helpers/constant/leader-permissions';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private _data = new BehaviorSubject<any>([]);
  private _leaderZoneAccess = new BehaviorSubject<boolean>(true);
  private _permissions = new BehaviorSubject<UserEmpowerments|undefined>(undefined);
  private _hasNotification = new BehaviorSubject<boolean>(false);
  private _selectedChurch = new BehaviorSubject<any>([]);
  private _removeConnectBadge = new BehaviorSubject<{type: string, id: number, number: number}>({type: 'init', id: 0, number: 0});

  constructor() { }

  removeGroupTeamBadge(type: 'group'|'team', id: number, number: number) {
    return this._removeConnectBadge.next({type, id, number});
  }

  hasNotification(hasNewNotification: boolean = false) {
    this._hasNotification.next(hasNewNotification);
  }
  hasNewNotification(): Observable<boolean> {
    return this._hasNotification.asObservable();
  }

  sendData(data: any) {
    this._data.next(data);
  }

  getData(): Observable<any> {
    return this._data.asObservable();
  }

  sharePermissions(data: UserEmpowerments) {
    this._permissions.next({...this._permissions.value, ...data});
  }

  getSharedPermissions(): Observable<UserEmpowerments|undefined> {
    return this._permissions.asObservable();
  }

  setLeaderZoneAccess(haveAccess: boolean = true) {
    this._leaderZoneAccess.next(haveAccess);
  }

  getLeaderZoneAccess(): Observable<boolean> {
    return this._leaderZoneAccess.asObservable();
  }

  switchChurch(data: any) {
    localStorage.setItem('selectedChurch', JSON.stringify(data));
    this._selectedChurch.next(data);
  }
  
  getSelectedChurch(): Observable<any> {
    return this._selectedChurch;
  }
}
